import React, { useEffect, useState } from 'react'
import ApiService from '../Services/ApiService';
import DataDog from '../Helpers/DataDog';
import UpdateCookies from './../Helpers/UpdateCookies';
import useConsultarProductosPremiumPorCrmId from './useConsultarProductosPremiumPorCrmId';
import { actualizarProductoPremiumPorParametro } from '../Services/ActualizarProcutoPremiumPorParametro';

const useObtenerEventosSuscripcionesOnDemand = (crmId) => {
    const { REACT_APP_APIPAYWALL } = process.env;
    const [isLoading, setIsLoading] = useState(true);
    const [eventos, setEventos] = useState([]);
    const [error, setError] = useState(null);
    const [productosPremium, errorProductos, isLoadingProductos, getProductosPremium] = useConsultarProductosPremiumPorCrmId();

    const buscarEvento = (contador, delay) => {
        let intentos = contador;
        let timeout = delay;
        setTimeout(() => {
            const fetchData = async () => {
                ApiService.post(`${REACT_APP_APIPAYWALL}EventosSuscripcionesV1/ObtenerEventosAccesosDigitales`)
                    .then(data => {
                        if (data && data.code === "0000") {
                            setEventos(data.response.evento)
                            if (data.response.evento?.EstadoTyC == "Activo" && data.response.evento?.EstadoSuscripcion == "Activa") {
                                UpdateCookies();
                            }
                            setIsLoading(false)
                        }
                        else {
                            if(intentos > 2){
                                getProductosPremium(crmId).then((resp)=> {
                                    if(resp?.code == "0000"){
                                        const pps = resp?.response?.ProductosPremiumId;
                                        if(pps){
                                            actualizarProductoPremiumPorParametro(pps);
                                        } else {
                                            DataDog.trackCustomEventError('error-actualizarProductoPremiumPorParametro', { error: resp.message });
                                            setError(true);
                                        }
                                    }
                                })
                                setIsLoading(false);
                            } else {
                                buscarEvento(intentos += 1, delay+500);
                            }
                        }
                    })
                    .catch(error => {
                        setError(error);
                        DataDog.trackCustomEventWarning('error-obtenerEvento-bonificado', { error: error });
                        setIsLoading(false);
                    });
            };
            fetchData();
        }, timeout);
    }

    useEffect(() => {
        buscarEvento(1, 500); //parametros iniciales
    }, []);

    return [eventos, error, isLoading];
}

export default useObtenerEventosSuscripcionesOnDemand